/**
 * Created by Victor Rojo on 19/10/18.
 */
import { Component, TemplateRef, ViewChild, ElementRef, OnDestroy }          from '@angular/core';
import { Router, ActivatedRoute, Params }                   from '@angular/router';
import { FormGroup, FormControl,
  FormBuilder, Validators }   from '@angular/forms'
import { NotificationsService }     from 'angular2-notifications';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation, NgxGalleryImageSize } from 'ngx-gallery';

import { Subject }            from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {distinctUntilChanged} from 'rxjs/operators';

import {NotificationService} from "../../notification/notification.service";
import {I18NService} from "../../shared/i18n/i18n.service";
import {Notification} from "../../model/notification";
import {IPlaceValuelistService} from "../../iPlace/iPlace-valuelist.service";
import {IPlaceDataChangeService} from "../IPlaceDataChange.service";
import {NotificationMessage} from "../notificationMessage/NotificationMessage";
import {TagService} from "../tag/Tag.service";
import {ItemTagType} from "../tag/Tag";
import {Globals} from "../../globals";


@Component({
  templateUrl: './CloudNotificationList.component.html',
  styleUrls: [ './CloudNotificationList.component.css'],
})
export class CloudNotificationListComponent implements OnDestroy{

  rows: Notification[] = [];
  private searchText= '';
  private searchTerms = new Subject<string>();
  isLoading = false;
  tableMessages: any;
  notificationPage: any;
  sort = 'insertedDate,desc';
  sorts = [{prop: 'insertedDate', dir: 'desc'}];
  statusFilterValues= [
    {real:null, display:"All"},
    {real:1, display:"Active"},
    {real:0, display:"Inactive"}];
  activetStatusFilterValue: number = null;
  modalRef: BsModalRef;
  notification: any;
  search: string;
  @ViewChild('detailTemplate', { static: true })
  private detailTempRef : TemplateRef<any>;
  private filter: string;
  private subscription: any;
  private reloadNotificationsTimeout:any;

  isLoadingDetail = true;
  galleryImages: any;
  galleryOptions: any;

  dropdownList:any = [];
  selectedItems:any = [];
  itemTags: any[] = [];
  iPlaceList:any[] = [];
  iPlaceMap:any[];
  dropdownSettings:any = {};
  tagDropdownSettings:any = {};
  advancedSearch:boolean = false;
  dateRangeFilter:any;
  bsConfig: Partial<BsDatepickerConfig>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    private i18nService: I18NService,
    private modalService: BsModalService,
    private displayNotificationService: NotificationsService,
    private localeService: BsLocaleService,
    private iPlaceDataChangeService: IPlaceDataChangeService,
    private tagService: TagService,
    private iPlaceValuelistService: IPlaceValuelistService,
    private globals: Globals) {

    this.notificationPage = {
      count: 0,
      pageSize: 15,
      offset: 0,
    };

    this.searchTerms
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe((result) => {
        this.searchText = result.toUpperCase();
        this.notificationPage.pageSize = 15;
        this.notificationPage.offset = 0;
        this.setNotificationPage(this.notificationPage);
      });

    this.route.params.subscribe((params: Params) => {
      if (params["filter"]) {
        this.searchText = params["filter"].toUpperCase();
        this.search = params["filter"];
      }
    });

    this.tableMessages = {};
    this.tableMessages.emptyMessage = this.i18nService.get("noDataToDisplay");
    this.tableMessages.totalMessage = this.i18nService.get("total");
    this.tableMessages.selectedMessage = this.i18nService.get("selected");

    this.galleryOptions = [
      {
        width: '800px',
        height: '600px',
        thumbnailsColumns: 4,
        imageAnimation: NgxGalleryAnimation.Slide,
        previewCloseOnEsc: true,
        previewKeyboardNavigation: true,
        imageSize: NgxGalleryImageSize.Contain
      },
    ];

    if ( (<any>Object).values(this.iPlaceValuelistService.getValuelist()).length ) {
      this.iPlaceList = (<any>Object).values(this.iPlaceValuelistService.getValuelist())
        .sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
      this.iPlaceMap = this.iPlaceList.reduce((previous:any, current:any) => {
        previous[current.id] = current;
        return previous;
      }, {});
    } else {
      this.iPlaceValuelistService.reload()
        .then( () => {
          this.iPlaceList = (<any>Object).values(this.iPlaceValuelistService.getValuelist())
            .sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
          this.iPlaceMap = this.iPlaceList.reduce((previous:any, current:any) => {
            previous[current.id] = current;
            return previous;
          }, {});
          if ( globals.tenant == "ecomanager" ) {
            this.setGroupedIPlaceList()
          } else {
            this.dropdownList = this.iPlaceList;
          }
        })
    }

    let iPlaceSelectorText = i18nService.get("selectiPlaces");
    let groupBy = null;
    if ( globals.tenant == "ecomanager" ) {
      iPlaceSelectorText =i18nService.get("selectStation");
      groupBy = "tag";
      this.activetStatusFilterValue = 1;
      this.tagService.getItemTags(ItemTagType.IPLACE)
        .then( itemTags => {
          this.itemTags = itemTags;
          this.setGroupedIPlaceList()
        });
    } else {
      this.dropdownList = this.iPlaceList;
    }

    this.dropdownSettings = {
      singleSelection: false,
      primaryKey: 'idiPlace',
      labelKey: 'iPlaceName',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: iPlaceSelectorText,
      searchPlaceholderText: i18nService.get("search"),
      badgeShowLimit: 2,
      enableSearchFilter: true,
      groupBy: groupBy,
      classes: "form-angular2-multiselect"
    };

    this.bsConfig = Object.assign({}, {containerClass: "theme-custom", showWeekNumbers: false});

    let startDate = new Date();
    startDate.setHours(0,0,0,0);
    let endDate = new Date();
    endDate.setHours(0,0,0,0);
    endDate = new Date(endDate.getTime() - 604800000);
    this.dateRangeFilter = [endDate, startDate];

    this.setNotificationPage(this.notificationPage);
  }

  private setGroupedIPlaceList(){
    if ( this.iPlaceMap ) {
      this.itemTags.forEach(itemTag => {
        let iplace = this.iPlaceMap[itemTag.id.itemId];
        if ( iplace && !iplace.tag ) {
          iplace.tag = itemTag.id.tagKey;
        }
      });

    }

    if ( this.iPlaceList.length ) {
      if ( !this.itemTags || !this.itemTags.length ) {
        this.dropdownSettings.groupBy = false;
      }
    }

    this.dropdownList = this.iPlaceList.sort((a:any,b:any) => {
      if ( !a.tag ) {
        return -1
      } else if (a.tag == b.tag) {
        return a.iPlaceName.localeCompare(b.iPlaceName);
      } else {
        return a.tag.localeCompare(b.tag);
      }
    });
  }

  toogleAdvancedSearch(){
    this.advancedSearch = !this.advancedSearch;
  }

  clearFilters(){
    this.selectedItems = null;
    this.dateRangeFilter = null;
    this.notificationPage.pageSize = 15;
    this.notificationPage.offset = 0;
    this.setNotificationPage(this.notificationPage);
  }

  onItemSelect(item: any) {
    this.notificationPage.pageSize = 15;
    this.notificationPage.offset = 0;
    this.setNotificationPage(this.notificationPage);
  }
  onSelectAll(items: any) {
    this.notificationPage.pageSize = 15;
    this.notificationPage.offset = 0;
    this.setNotificationPage(this.notificationPage);
  }

  onDateRangeChange(any:any){
    this.notificationPage.pageSize = 15;
    this.notificationPage.offset = 0;
    this.setNotificationPage(this.notificationPage);

  }
  onSearch(term: string){
    this.searchTerms.next(term);
  }

  setNotificationPage(pageInfo:any){
    if ( this.reloadNotificationsTimeout ) {
      clearTimeout(this.reloadNotificationsTimeout);
    }
    this.isLoading = true;
    this.notificationPage.offset = pageInfo.offset;
    let filter = "";
    if ( this.activetStatusFilterValue != null ) {
      filter = "isActiveFilter:=:" + ( this.activetStatusFilterValue ? "true" : "false") + ":B";
    }
    if ( this.searchText ) {
      let or = filter ? ";" : "";
      filter += this.searchText ? or + "|iPlace.iPlaceName:ilike:" + this.searchText + ";|name:ilike:" + this.searchText
      + ";|description:ilike:" + this.searchText: "";
    }
    if ( this.selectedItems && this.selectedItems.length ) {
      let or = filter ? ";" : "";
      filter +=  or + "idiPlace:in:" + this.selectedItems.map(e => e.idiPlace).join(",");
    }
    if ( this.dateRangeFilter && this.dateRangeFilter.length == 2 ) {
      let or = filter ? ";" : "";
      filter +=  or + "insertedDate:>=:" + this.dateRangeFilter[0].getTime() + ":T;insertedDate:<:" + (this.dateRangeFilter[1].getTime() + 86400000)+ ":T";
    }

    this.notificationService.getPage(pageInfo.offset,pageInfo.pageSize -1,this.sort, filter)
      .then( response => {
        this.isLoading = false;
        let sort = response.sort ? response.sort[0].property + "," + response.sort[0].direction : "";
        this.notificationPage = {
          count: response.totalElements,
          pageSize: response.size,
          offset: response.number
        };
        this.rows = response.content;
        this.sorts = [{prop: response.sort[0].property, dir: response.sort[0].direction.toLowerCase()}];
        let notificationIds = this.rows
          .filter((notification:Notification) => !notification.isRead)
          .map((notification:Notification) => notification.notificationId);
        if ( notificationIds && notificationIds.length ) {
          this.notificationService.ack(notificationIds);
        }
      })
      .catch( error => {
        this.isLoading = false;
      });
  }

  onSort(event:any) {
    let prop = event.sorts[0].prop == "idiPlace" ? "iPlace.iPlaceName" : event.sorts[0].prop;
    this.sort = prop + "," + event.sorts[0].dir;
    this.setNotificationPage(this.notificationPage);
  }

  getNotificationLevelClass(notificationLevel: number){
    switch (notificationLevel) {
      case 1:
        return "row-info";
      case 2:
        return "row-warning";
      case 3:
        return "row-error";
      case 4:
        return "row-fatal";
    }
  }

  onActivate(event: any) {
    if ( event.type == 'click' && event.column.prop) {
      this.notification = event.row;

      this.modalRef = this.modalService.show(this.detailTempRef);
      let promise = this.loadNotification(event.row.id);
      promise.catch( (error:any) => {
        this.modalService.hide(1);
      });
    }
  }

  onClickStatusFilter(value: number): void{
    if ( value != this.activetStatusFilterValue ) {
      this.activetStatusFilterValue = value;
      this.notificationPage.pageSize = 15;
      this.notificationPage.offset = 0;
      this.setNotificationPage(this.notificationPage);
    }
  }

  public ngOnDestroy(): void {
    if ( this.subscription ) {
      this.subscription.unsubscribe();
    }
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  loadNotification(id:string):Promise<any> {
    this.isLoadingDetail = true;
    return this.notificationService.get(id)
      .then( notification => {
        this.notification = notification;
        this.isLoadingDetail = false;
        if ( notification.screenShots ) {
          this.galleryImages = notification.screenShots
            .split(",")
            .map((s:string) => {
              return {
                small: "api/v1/notification/screenshot/" + s,
                medium: "api/v1/notification/screenshot/" + s,
                big: "api/v1/notification/screenshot/" + s}
            });
        }
      })
      .catch( error => {
        this.isLoadingDetail = false;
        return Promise.reject(error.error || error)
      });
  }

  hide() {
    this.modalService.hide(1);
  }
}
